import { render, staticRenderFns } from "./home-video.vue?vue&type=template&id=7bd736d1&lang=pug&"
import script from "./home-video.vue?vue&type=script&lang=js&"
export * from "./home-video.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports